import { Link } from "react-router-dom";
import { articles } from "@/mocks/articles";
import ArticleCard from "@/components/feature/ArticleCard";
import SectionHeading from "@/components/feature/SectionHeading";
import { formatViews, formatDate } from "@/utils/format";

export default function LatestRanking() {
  const latest = [...articles].sort((a, b) => (a.date < b.date ? 1 : -1)).slice(0, 6);
  const ranking = [...articles].sort((a, b) => b.views - a.views).slice(0, 6);
  const tagPool = Array.from(new Set(articles.flatMap((a) => a.tags))).slice(0, 14);

  return (
    <section className="w-full bg-background-100/60">
      <div className="mx-auto max-w-[1240px] px-4 py-10 md:px-6 md:py-12">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-3">
          <div className="lg:col-span-2">
            <SectionHeading
              title="最新更新"
              subtitle="每日 08:00 前完成更新，先到先吃"
              icon="ri-time-line"
              moreTo="/category/society"
              moreLabel="全部更新"
            />
            <div className="flex flex-col gap-4">
              {latest.map((a) => (
                <div key={a.slug} className="flex flex-col gap-1">
                  <ArticleCard article={a} variant="horizontal" />
                </div>
              ))}
            </div>
          </div>

          <aside className="flex flex-col gap-6">
            <div className="rounded-lg border border-background-200/80 bg-background-50 p-5">
              <h2 className="mb-4 flex items-center gap-2 border-b border-background-200 pb-3 font-heading text-lg font-bold text-foreground-950">
                <i className="ri-bar-chart-box-fill text-primary-500" aria-hidden="true" />
                阅读热榜
              </h2>
              <ol className="flex flex-col">
                {ranking.map((a, idx) => (
                  <li key={a.slug}>
                    <Link
                      to={`/article/${a.slug}`}
                      className="group flex cursor-pointer items-start gap-3 border-b border-background-100 py-3 last:border-0"
                    >
                      <span
                        className={`font-heading text-lg font-bold leading-none ${
                          idx < 3 ? "text-primary-500" : "text-background-400"
                        }`}
                      >
                        {String(idx + 1).padStart(2, "0")}
                      </span>
                      <div className="min-w-0">
                        <h3 className="line-clamp-2 text-sm font-medium leading-snug text-foreground-800 transition-colors group-hover:text-primary-600">
                          {a.title}
                        </h3>
                        <span className="mt-1 block text-xs text-foreground-500">
                          {formatViews(a.views)} 阅读 · {formatDate(a.date)}
                        </span>
                      </div>
                    </Link>
                  </li>
                ))}
              </ol>
            </div>

            <div className="rounded-lg border border-background-200/80 bg-background-50 p-5">
              <h2 className="mb-4 flex items-center gap-2 border-b border-background-200 pb-3 font-heading text-lg font-bold text-foreground-950">
                <i className="ri-price-tag-3-fill text-accent-600" aria-hidden="true" />
                热门标签
              </h2>
              <div className="flex flex-wrap gap-2">
                {tagPool.map((t) => (
                  <span
                    key={t}
                    className="cursor-pointer rounded-full bg-secondary-100 px-3 py-1.5 text-xs font-medium text-secondary-900 transition-colors hover:bg-accent-100 hover:text-accent-800"
                  >
                    #{t}
                  </span>
                ))}
              </div>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}